import React, { Component } from "react";
import AntdRate, {RateProps} from "antd/lib/rate";
import "antd/lib/rate/style";

interface RProps extends RateProps {
  forwardedRef?: any;
};
class Rate extends Component<RProps> {
  render() {
    const { forwardedRef, ...rest } = this.props;
    return <AntdRate ref={forwardedRef} {...rest} />;
  }
}
export default React.forwardRef((props: RProps, ref) => {
  return <Rate {...props} forwardedRef={ref} />;
});



// WEBPACK FOOTER //
// ./src/components/rate/index.tsx